import { Chip, ChipProps } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';

import { ModeType, Size } from 'theme/enums';

interface IProps extends ChipProps {
  borderRadius?: number;
  backgroundColor?: string;
}

export const NeutralChip = ({ borderRadius = 3, backgroundColor, ...props }: IProps) => {
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === ModeType.DARK;
  const resolvedBackgroundColor = backgroundColor ?? theme.palette.neutral[isDarkMode ? 300 : 200];

  return (
    <Chip
      size={Size.SM || props.size}
      {...props}
      slotProps={{
        action: {
          sx: {
            borderRadius,
            backgroundColor: resolvedBackgroundColor,
            '&:hover': { backgroundColor: resolvedBackgroundColor },
          },
          ...props?.slotProps?.action,
        },
        ...props?.slotProps,
      }}
    >
      {props.children}
    </Chip>
  );
};
